// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2WZk9","link":"styles_link__3EKdJ","activeLink":"styles_activeLink__CF4Ob"};